import template from './last-seen-filter.html';
import * as LastSeenModels from './last-seen-filter.models';

class LastSeenFilterController {
  constructor() {
    'ngInject';
    this.open = false;
    this.minRange = null;
    this.maxRange = null;
    this.options = LastSeenModels.LastSeenOptions;
  }

  $onInit() {}
  $onDestroy() {}
  $onChanges() {
    const {range} = this.selected || {};
    const {min, max} = range || {};
    this.minRange = min;
    this.maxRange = max;
  }

  toggleOpen() {
    this.open = !this.open;
  }
  close() {
    this.open = false;
  }

  toggleOptionSelection(option) {
    //clear the option if its been selected
    if (this.selected && option && this.selected.id === option.id) {
      this.onSelectionUpdated(null);
    } else {
      this.onSelectionUpdated({option});
    }
    this.close();
  }

  isValidRange() {
    const diff = this.maxRange - this.minRange;
    return this.maxRange && this.maxRange < 1000 && diff > 0;
  }

  applyCustomRange() {
    if (this.isValidRange()) {
      const min = this.minRange ? Number(this.minRange) : null;
      const max = this.maxRange ? Number(this.maxRange) : null;
      const option = LastSeenModels.getLastSeenOptionByMinMax(min, max);
      this.onSelectionUpdated({option});
    }
    this.close();
  }
}

export default {
  template,
  controller: LastSeenFilterController,
  controllerAs: 'lsfVm',
  bindings: {
    selected: '<',
    onSelectionUpdated: '&'
  }
};
